module.exports = {
    doublegame: {}
};



//////////////////
// WEBPACK FOOTER
// ./cfg/doublegame-config.js
// module id = 40
// module chunks = 0